import styled from '@emotion/styled';
import { Flex } from 'components';

export const AttachmentText = styled.p`
  margin: 0;
  text-align: center;
  color: ${({ theme }) => theme.colors.secondary};
`;

export const AttachmentLink = styled.a`
  display: flex;
  flex-direction: column;
  margin: 15px 15px 0 0;
  align-items: center;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.secondary};

  .MuiSvgIcon-root {
    font-size: 80px;
    color: ${({ theme }) => theme.colors.action};
  }
`;

export const AttachmentWrapper = styled(Flex)`
  flex-wrap: wrap;
`;
